import React, { useState, useEffect } from 'react';
import axios from 'axios';

const CarHireServices = () => {
    const [aboutSection, setAboutSection] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fetchAboutSection();
    }, []);

    const fetchAboutSection = async () => {
        try {
            const response = await axios.get('/api/car-hire/about/');
            setAboutSection(response.data);
        } catch (error) {
            console.error('Error fetching about section:', error);
            // Use default content if API fails
            setAboutSection({
                subtitle: "Why Choose Us",
                title: "Your Trusted Car Rental Partner",
                description: "We offer the best car rental deals from top companies worldwide.",
                feature1_icon: "fas fa-car",
                feature1_title: "Wide Selection",
                feature1_description: "Choose from hundreds of vehicles from trusted rental companies.",
                feature2_icon: "fas fa-dollar-sign",
                feature2_title: "Best Prices",
                feature2_description: "Compare prices and find the best deals on car rentals.",
                feature3_icon: "fas fa-headset",
                feature3_title: "24/7 Support",
                feature3_description: "Get help whenever you need it with our round-the-clock support.",
                image1: "assets/images/services/car-rental-service1.jpg",
                image2: "assets/images/services/car-rental-service2.jpg"
            });
        } finally {
            setIsLoading(false);
        }
    };

    if (isLoading) {
        return (
            <section className="services__area section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12 text-center">
                            <i className="fas fa-spinner fa-spin fa-2x"></i>
                            <p>Loading services...</p>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <section className="services__area section-padding">
            <div className="container">
                <div className="row align-items-center">
                    {/* Images Section */}
                    <div className="col-xl-6 col-lg-6">
                        <div className="services__area-image">
                            <div className="services__area-image-wrapper">
                                <div className="services__area-image-one">
                                    <img 
                                        src={aboutSection.image1 || 'assets/images/services/car-rental-service1.jpg'} 
                                        alt="Car Rental Service"
                                        onError={(e) => {
                                            e.target.src = 'assets/images/services/default-service.jpg';
                                        }}
                                    />
                                </div>
                                {aboutSection.image2 && (
                                    <div className="services__area-image-two">
                                        <img 
                                            src={aboutSection.image2} 
                                            alt="Car Rental Service"
                                            onError={(e) => {
                                                e.target.style.display = 'none';
                                            }}
                                        />
                                    </div>
                                )}
                            </div>
                            <div className="services__area-image-experience">
                                <div className="services__area-image-experience-content">
                                    <h3>15+</h3>
                                    <span>Years Experience</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    {/* Content Section */}
                    <div className="col-xl-6 col-lg-6">
                        <div className="services__area-content">
                            <div className="services__area-content-title">
                                <span>{aboutSection.subtitle}</span>
                                <h2>{aboutSection.title}</h2>
                                <p>{aboutSection.description}</p>
                            </div>
                            
                            <div className="services__area-content-service">
                                {/* Feature 1 */}
                                <div className="services__area-content-service-item">
                                    <div className="services__area-content-service-item-icon">
                                        <i className={aboutSection.feature1_icon}></i>
                                    </div>
                                    <div className="services__area-content-service-item-content">
                                        <h5>{aboutSection.feature1_title}</h5>
                                        <p>{aboutSection.feature1_description}</p>
                                    </div>
                                </div>
                                
                                {/* Feature 2 */}
                                <div className="services__area-content-service-item">
                                    <div className="services__area-content-service-item-icon">
                                        <i className={aboutSection.feature2_icon}></i>
                                    </div>
                                    <div className="services__area-content-service-item-content">
                                        <h5>{aboutSection.feature2_title}</h5>
                                        <p>{aboutSection.feature2_description}</p>
                                    </div>
                                </div>
                                
                                {/* Feature 3 */}
                                <div className="services__area-content-service-item">
                                    <div className="services__area-content-service-item-icon">
                                        <i className={aboutSection.feature3_icon}></i>
                                    </div>
                                    <div className="services__area-content-service-item-content">
                                        <h5>{aboutSection.feature3_title}</h5>
                                        <p>{aboutSection.feature3_description}</p>
                                    </div>
                                </div>
                            </div>
                            
                            {/* Additional Features */}
                            <div className="services__area-content-features">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="feature-item">
                                            <i className="fas fa-check-circle text-success"></i>
                                            <span>Free Cancellation</span>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="feature-item">
                                            <i className="fas fa-check-circle text-success"></i>
                                            <span>No Hidden Fees</span>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="feature-item">
                                            <i className="fas fa-check-circle text-success"></i>
                                            <span>Price Match Guarantee</span>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="feature-item">
                                            <i className="fas fa-check-circle text-success"></i>
                                            <span>Instant Confirmation</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="services__area-content-btn">
                                <a href="/car-hire/search" className="btn-one">
                                    {aboutSection.button_text || "Start Searching"} <i className="fas fa-chevron-right"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CarHireServices;
